import React, { Component } from 'react';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { withApollo, graphql, compose } from 'react-apollo';
import {
  Modal,
  Layout,
  Table,
  Row,
  Col,
  Button,
  Select,
  Tag,
  Menu,
  Input,
  Dropdown,
  DatePicker,
  Popover,
  notification,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';

import getExpedientePorId from '../../../graphql/querys/contravenciones/getExpedientePorId.graphql';
import getActuacionMinio from '../../../graphql/querys/contravenciones/getActuacionMinio.graphql';
import buscarAntecedentes from '../../../graphql/querys/contravenciones/buscarAntecedentes.graphql';
import antecedentes from '../../../graphql/querys/contravenciones/antecedentes.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getArticulos from '../../../graphql/querys/contravenciones/getArticulos.graphql';
import sacarContraventor from '../../../graphql/mutations/contravenciones/sacarContraventor.graphql';
import actualizarCaratula from '../../../graphql/mutations/contravenciones/actualizarCaratula.graphql';
import actualizarFechaHecho from '../../../graphql/mutations/contravenciones/actualizarFechaHecho.graphql';
import actualizarArticulos from '../../../graphql/mutations/contravenciones/actualizarArticulos.graphql';
import actualizarNumeroExpPolicial from '../../../graphql/mutations/contravenciones/actualizarNumeroExpPolicial.graphql';
import deleteActuacion from '../../../graphql/mutations/contravenciones/deleteActuacion.graphql';
import deleteRecibo from '../../../graphql/mutations/contravenciones/deleteRecibo.graphql';
import confirmarActuacion from '../../../graphql/mutations/contravenciones/confirmarActuacion.graphql';
import agregarRegistroAuditoria from '../../../graphql/mutations/contravenciones/agregarRegistroAuditoria.graphql';
import absolverContraventor from '../../../graphql/mutations/contravenciones/absolverContraventor.graphql';
import prescribirContraventor from '../../../graphql/mutations/contravenciones/prescribirContraventor.graphql';
import desestimarContraventor from '../../../graphql/mutations/contravenciones/desestimarContraventor.graphql';
import eliminarEstadoContraventor from '../../../graphql/mutations/contravenciones/eliminarEstadoContraventor.graphql';
import updateEstadoExpediente from '../../../graphql/mutations/contravenciones/updateEstadoExpediente.graphql';
import insertRecibo from '../../../graphql/mutations/contravenciones/insertRecibo.graphql';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsExpedientes from '../../../actions/expediente';
import * as actionsContraventores from '../../../actions/contraventores';
import * as actionsMain from '../../../actions/main';

import DetalleContraventor from './DetalleContraventor';
import SumarContraventor from './SumarContraventor';
import ModalSancion from './ModalSancion';
import ModalAntecedentes from './ModalAntecedentes';
import ModalUploader from './documentos/ModalUploader';
import ModalAuditoriaActuacion from './ModalAuditoriaActuacion';
import ModalActualizarDireccion from './ModalActualizarDireccion';

import { imprimir } from '../../common/funciones/imprimir';

import { imprimirCaratula } from './imprimir/imprimirCaratula';

import moment from 'moment';

import {
  FaBalanceScale,
  FaAddressCard,
  FaDollarSign,
  FaSearch,
  FaTrash,
  FaEdit,
} from 'react-icons/fa';
import { errorService } from '../../../graphql/utils/utils';
import ModalMandarEmail from './email/ModalMandarEmail';
import { verPdf } from '../../common/funciones/verPdf';
import ModalVisorEmail from '../../common/ModalVisorEmail';
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};
const { TextArea } = Input;
const confirm = Modal.confirm;
const Option = Select.Option;

@compose(
  graphql(getExpedientePorId, {
    options: props => ({
      variables: {
        _id: props.match.params.id,
      },
      fetchPolicy: 'network-only',
      onCompleted: data => {
        // console.log('HOLA');
        props.actionsExpedientes.setExpediente(data.getExpedientePorId);
        // console.log('Estoy en...');
        // console.log(data);
        if (data.getExpedientePorId) {
          props.actionsContraventores.agregarContraventores(
            data.getExpedientePorId.contraventores
          );
        }
        // console.log('CHAU');
      },
    }),
  }),
  graphql(getArticulos, { name: 'getArticulos' }),
  graphql(sacarContraventor, { name: 'sacarContraventor' }),
  graphql(actualizarCaratula, { name: 'actualizarCaratula' }),
  graphql(actualizarFechaHecho, { name: 'actualizarFechaHecho' }),
  graphql(actualizarNumeroExpPolicial, { name: 'actualizarNumeroExpPolicial' }),
  graphql(absolverContraventor, { name: 'absolverContraventor' }),
  graphql(prescribirContraventor, { name: 'prescribirContraventor' }),
  graphql(desestimarContraventor, { name: 'desestimarContraventor' }),
  graphql(eliminarEstadoContraventor, {
    name: 'eliminarEstadoContraventor',
    options: {
      refetchQueries: [{ query: getExpedientePorId }],
    },
  }),
  graphql(actualizarArticulos, { name: 'actualizarArticulos' }),
  graphql(deleteActuacion, { name: 'deleteActuacion' }),
  graphql(deleteRecibo, { name: 'deleteRecibo' }),
  graphql(confirmarActuacion, { name: 'confirmarActuacion' }),
  graphql(agregarRegistroAuditoria, { name: 'agregarRegistroAuditoria' }),
  graphql(updateEstadoExpediente, { name: 'updateEstadoExpediente' }),
  graphql(updateEstadoExpediente, { name: 'updateEstadoExpediente' }),
  graphql(insertRecibo, {
    name: 'insertRecibo',
  }),
  graphql(getUsuario, {
    name: 'getUsuario',
  })
)
class VerExpediente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingConfirmar: false,
      visible: false,
      visibleSancion: false,
      visibleActualizarDireccion: false,
      contraventorMostrar: {},
      caratulaEditable: false,
      textoCaratula: '',
      expedientesAntecedentes: [],
      expedientesAntecedentesExternos: [],
      mostrarModalAntecedentes: false,
      mostrarModalAuditoriaActuacion: false,
      visibleModalUploader: false,
      generarRecibo: false,
      idModeloRecibo: '',
      actuacion: {},
      estado: null,
      visibleModalMandarEmail: false,
      visibleModalVisorEmail: false,
      idDocumento: null,
      loadingConfirmarActuacion: false,
    };
  }

  volver = () => {
    // this.props.history.push('/contravenciones/expedientes');
    this.props.history.goBack();
  };

  finalizarGeneracionRecibo = () => {
    // console.log('ENTRE A FINALIZAR ESTO!!!');
    this.setState({
      generarRecibo: false,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      // console.log('THIS PROPS: ', this.props);
      // console.log('Las nextProps son...', nextProps);
      if (
        !this.props.data.getExpedientePorId &&
        nextProps.data.getExpedientePorId
      ) {
        this.setState({
          caratula: nextProps.data.getExpedientePorId.caratula,
        });
      }
    } catch (err) {
      console.log('ERROR EN EL RECEIVE PROPS');
      console.log(err);
    }
  }

  generarOpcionesIniciales = () => {
    //Metodo que se encarga de generar el arreglo de valores para el selector multiple de categorias.
    let valores = [];
    if (!this.props.data.loading && this.props.expediente.articulos) {
      this.props.expediente.articulos.map(articulo => {
        valores.push(articulo._id);
      });
    }

    // console.log("Los valores por defecto quedan... ", valores);

    return valores;
  };

  sacarContraventor = () => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este contraventor?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .sacarContraventor({
            variables: {
              _id: yo.props.expediente._id,
              idContraventor: yo.state.contraventorMostrar._id,
            },
          })
          .then(respuesta => {
            // console.log('La respuesta es....');
            // console.log(respuesta);

            if (respuesta.data.sacarContraventor) {
              notification.warning({
                message: 'Contraventor Eliminado del Expediente',
                description:
                  'El contraventor fue eliminado del expediente con exito',
              });
            }
          })
          .catch(err => {
            console.log('Existe un error al sacar un contraventor');
            console.log(err);
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  handleChange = () => {
    // console.log(`Selected: ${value}`);
  };

  mostrarDetallesContraventor = () => {
    this.setState({
      visibleSumarContraventor: true,
    });
  };

  ocultarDetallesContraventor = () => {
    this.setState({
      visibleSumarContraventor: false,
      contraventorMostrar: {},
    });
  };

  mostrarModalUploader = () => {
    this.setState({
      visibleModalUploader: true,
    });
  };

  ocultarModalUploader = () => {
    this.setState({
      visibleModalUploader: false,
      contraventorMostrar: {},
    });
  };

  mostrarModalAuditoriaActuacion = record => {
    this.setState({
      mostrarModalAuditoriaActuacion: true,
      actuacion: record,
    });
  };

  ocultarModalAuditoriaActuacion = () => {
    this.setState({
      mostrarModalAuditoriaActuacion: false,
      actuacion: {},
    });
  };

  mostrarSancion = () => {
    this.setState({
      visibleSancion: true,
    });
  };

  ocultarSancion = () => {
    this.setState({
      visibleSancion: false,
    });
  };

  mostrarModalDireccion = () => {
    // console.log('VOY A MOSTRAR: ');
    // console.log(record);
    // console.log(this.state.contraventorMostrar);
    this.setState({
      visibleActualizarDireccion: true,
    });
  };

  ocultarModalDireccion = () => {
    this.setState({
      visibleActualizarDireccion: false,
    });
  };

  crearOpciones(articulo) {
    return (
      <Option key={articulo._id} value={articulo._id}>
        {articulo.nombre}
      </Option>
    );
  }

  guardarCaratula = () => {
    // console.log('CARATULA');
    // console.log(this.state.caratula);
    this.props
      .actualizarCaratula({
        variables: {
          _id: this.props.expediente._id,
          caratula: this.state.caratula,
        },
      })
      .then(respuesta => {
        // console.log('La respuesta que recibi del server fue');
        // console.log(respuesta);

        if (respuesta.data.actualizarCaratula) {
          this.setState(
            {
              caratulaEditable: false,
            },
            () => {
              notification.success({
                message: 'Actualizacion de caratula correcta',
                description:
                  'Se registró correctamente la nueva caratula del expediente',
              });
            }
          );
        }
      })
      .catch(err => {
        console.log('ERRORRRR');
        console.log(err);
        errorService(err, {
          _id: this.props.expediente._id,
          caratula: this.state.caratula,
        });
      });
  };

  // componentWillUnmount() {
  //   this.props.actionsMain.reiniciar();
  // }

  // eslint-disable-next-line no-unused-vars
  enCambioFechadelhecho = (date, dateString) => {
    this.props
      .actualizarFechaHecho({
        variables: {
          _id: this.props.expediente._id,
          fechaHecho: date.toDate(),
        },
      })
      .then(res => {
        if (res.data.actualizarFechaHecho) {
          notification.success({
            message: 'Actualizacion de fecha del hecho correcta',
            description:
              'Se registró correctamente la nueva fecha del hecho del expediente',
          });

          this.props.data
            .refetch({
              _id: this.props.match.params.id,
            })
            .catch(err => {
              console.log('ERROR EN EL REFETCH');
              console.log(err);
              errorService(err, {
                _id: this.props.match.params.id,
              });
            });
        }
      })
      .catch(err => {
        console.log('error ', err);
        errorService(err, {
          _id: this.props.expediente._id,
          fechaHecho: date.toDate(),
        });
      });
  };

  enCambioNumeroExpPolicial = numeroExpPolicial => {
    // console.log('Entre con: ', numeroExpPolicial);
    this.props
      .actualizarNumeroExpPolicial({
        variables: {
          _id: this.props.expediente._id,
          numero: numeroExpPolicial,
        },
      })
      .then(res => {
        if (res.data.actualizarNumeroExpPolicial) {
          notification.success({
            message:
              'Actualizacion del numero del expediente policial realizada correctamente.',
          });
        }
      })
      .catch(err => {
        console.log('error ', err);
        errorService(err, {
          _id: this.props.expediente._id,
          numero: numeroExpPolicial,
        });
      });
  };

  absolverContraventor = () => {
    this.props
      .absolverContraventor({
        variables: {
          _id: this.state.contraventorMostrar._id,
        },
      })
      .then(res => {
        // console.log('La respuesta es: ', res);

        if (res.data.absolverContraventor) {
          notification.info({
            message: 'Contraventor Absuelto Correctamente',
            description: 'El contraventor fue absuelto correctamente',
          });
        }
      })
      .catch(err => {
        console.log('ERROR');
        console.log(err);
        errorService(err, {
          _id: this.state.contraventorMostrar._id,
        });
        Modal.error({
          title: 'Error a la hora de emitir la absolucion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  prescribirContraventor = () => {
    this.props
      .prescribirContraventor({
        variables: {
          _id: this.state.contraventorMostrar._id,
        },
      })
      .then(res => {
        // console.log('La respuesta es: ', res);

        if (res.data.prescribirContraventor) {
          notification.info({
            message: 'Contraventor Prescripto Correctamente',
            description: 'El contraventor fue prescripto correctamente',
          });
        }
      })
      .catch(err => {
        console.log('ERROR');
        console.log(err);
        errorService(err, {
          _id: this.state.contraventorMostrar._id,
        });
        Modal.error({
          title: 'Error a la hora de emitir la prescripcion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  desestimarContraventor = () => {
    this.props
      .desestimarContraventor({
        variables: {
          _id: this.state.contraventorMostrar._id,
        },
      })
      .then(res => {
        // console.log('La respuesta es: ', res);

        if (res.data.desestimarContraventor) {
          notification.info({
            message: 'La acusacion contra el contraventor fue desestimada.',
            description: 'El cambio se produjo correctamente.',
          });
        }
      })
      .catch(err => {
        console.log('ERROR');
        console.log(err);
        errorService(err, {
          _id: this.state.contraventorMostrar._id,
        });
        Modal.error({
          title: 'Error a la hora de emitir la desestimacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  eliminarEstado = () => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar el estado de este contraventor?',
      content:
        'Esta accion implica restablecer el estado del contraventor, volver su estado a PRESUNTO CONTRAVENTOR y eliminar el recibo de pago del mismo si lo tuviera.',
      onOk() {
        yo.props
          .eliminarEstadoContraventor({
            variables: {
              _id: yo.state.contraventorMostrar._id,
            },
          })
          .then(res => {
            // console.log('La respuesta es: ', res);

            if (res.data.eliminarEstadoContraventor) {
              notification.info({
                message:
                  'Se elimino todo lo relacionado con el estado del contraventor',
                description: 'El cambio se produjo correctamente.',
              });
            }
          })
          .catch(err => {
            console.log('ERROR');
            console.log(err);
            errorService(err, {
              _id: yo.state.contraventorMostrar._id,
            });
            Modal.error({
              title: 'Error a la hora de eliminar el estado',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  actualizarArticulos = articulos => {
    this.props
      .actualizarArticulos({
        variables: {
          _id: this.props.expediente._id,
          articulos: articulos,
        },
      })
      .then(res => {
        if (res.data.actualizarArticulos) {
          notification.success({
            message: 'Actualizacion de los articulos correcta',
            description:
              'Se registró correctamente los articulos del expediente',
          });

          // console.log('RESULTADO: ', res.data.actualizarArticulos);
          //Aca debo llamar a redux:
          this.props.actionsExpedientes.setExpediente({
            ...this.props.expediente,
            articulos: res.data.actualizarArticulos.articulos,
          });
        }
      })
      .catch(err => {
        console.log('error ', err);
        errorService(err, {
          _id: this.props.expediente._id,
          articulos: articulos,
        });
      });
  };

  buscarAntecedentes = () => {
    // console.log('Voy a buscar los antecedentes para: ', this.state.contraventorMostrar);

    this.setState({
      ...this.state,
      loading: true,
    });
    this.props.client
      .query({
        query: buscarAntecedentes,
        variables: {
          tipo_doc: this.state.contraventorMostrar.persona.tipo_doc,
          num_doc: this.state.contraventorMostrar.persona.num_doc,
        },
      })
      .then(respuesta => {
        if (respuesta.data.buscarAntecedentes) {
          console.log(
            'Respuesta BUSCARON: ',
            respuesta.data.buscarAntecedentes
          );
          this.props.client
            .query({
              query: antecedentes,
              variables: {
                tipoDoc: this.state.contraventorMostrar.persona.tipo_doc,
                numDoc: this.state.contraventorMostrar.persona.num_doc,
              },
            })
            .then(res => {
              console.log('RECIBI RESPEUSTA EXTERNA: ', res);

              notification.info({
                message: 'Busqueda realizada con exito.',
              });

              let exp = [];
              let expedientes = respuesta.data.buscarAntecedentes;
              expedientes.forEach(element => {
                if (element._id != this.props.expediente._id) {
                  exp.push(element);
                }
              });
              this.setState({
                expedientesAntecedentes: exp,
                expedientesAntecedentesExternos: res.data.antecedentes
                  ? res.data.antecedentes.antecedentes
                  : [],
                mostrarModalAntecedentes: true,
                loading: false,
              });
            })
            .catch(error => {
              console.log('error interno al buscar antecedentes: ', error);
              errorService(error, {
                tipoDoc: this.state.contraventorMostrar.persona.tipo_doc,
                numDoc: this.state.contraventorMostrar.persona.num_doc,
              });
              notification.error({
                message:
                  'Error al buscar los antecedentes dentro de Justicia de Paz',
              });

              this.setState({
                loading: false,
              });
            });
        } else {
          notification.error({
            message: 'No se encontraron Antecedentes',
          });
        }
      })
      .catch(err => {
        console.log('error ', err);
        notification.error({
          message:
            'Error al buscar los antecedentes externos a la Justicia de Paz',
        });
        errorService(err, {
          tipoDoc: this.state.contraventorMostrar.persona.tipo_doc,
          numDoc: this.state.contraventorMostrar.persona.num_doc,
        });
        this.setState({
          loading: false,
        });
      });
  };

  ocultarModalAntecendetes = () => {
    this.setState({
      mostrarModalAntecedentes: false,
    });
  };

  descargarArchivo = record => {
    this.props.client
      .query({
        query: getActuacionMinio,
        variables: {
          bucket: 'jdepaz',
          archivoId: record.urlMinio,
        },
      })
      .then(respuesta => {
        if (respuesta.data.getActuacionMinio) {
          verPdf(
            respuesta.data.getActuacionMinio,
            `${record.nombre}_${record._id}`
          );
        }
      })
      .catch(err => {
        notification.error({
          message: 'Error al obtener el documento',
          description:
            'Es probable que el documento no exista o no se haya encontrado',
        });
        console.log('Error al obtener el documento de minio');
        console.log(err);
        errorService(err, {
          mutation: 'GET ACTUACION MINIO',
          record: record,
        });
      });
  };

  converBase64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    const byteCharacters = window.atob(content); // method which converts base64 to binary
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType,
    }); // statement which creates the blob
    return blob;
  };

  eliminarActuacion = record => {
    Modal.confirm({
      title: 'Esta seguro de que desea eliminar el documento?',
      content: 'Esta accion NO podrá deshacerse.',
      onOk: () => {
        if (record.tipo == 'RECIBO') {
          this.props
            .deleteRecibo({
              variables: {
                _id: record._id,
              },
            })
            .then(respuesta => {
              if (respuesta.data.deleteRecibo) {
                notification.warning({
                  message: 'Recibo Eliminada del Expediente',
                  description:
                    'La actuacion fue eliminada del expediente con exito',
                });

                this.props.data
                  .refetch({
                    _id: this.props.match.params.id,
                  })
                  .catch(err => {
                    console.log('ERROR EN EL REFETCH');
                    console.log(err);
                    errorService(err, {
                      _id: record._id,
                    });
                  });
              }
            })
            .catch(err => {
              console.log('Exitio un error: ', err);
              errorService(err, {
                _id: record._id,
              });
            });
        } else {
          this.props
            .deleteActuacion({
              variables: {
                _id: record._id,
              },
            })
            .then(respuesta => {
              if (respuesta.data.deleteActuacion) {
                notification.warning({
                  message: 'Actuacion Eliminada del Expediente',
                  description:
                    'La actuacion fue eliminada del expediente con exito',
                });

                this.props.data
                  .refetch({
                    _id: this.props.match.params.id,
                  })
                  .catch(err => {
                    console.log('ERROR EN EL REFETCH');
                    console.log(err);
                    errorService(err, {
                      _id: this.props.match.params.id,
                    });
                  });
              }
            })
            .catch(err => {
              console.log('Exitio un error: ', err);
              errorService(err, {
                _id: record._id,
              });
            });
        }
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  imprimirCaratula = () => {
    const expediente =
      this.props.data.getExpedientePorId || this.props.expediente;
    imprimirCaratula(expediente);
  };

  actualizarEstado = estado => {
    let bandera = true;

    if (estado == 'FINALIZADO') {
      //Debo comprobar de que todos los contraventores no le falten asignar estado.

      _.forEach(this.props.contraventores, contraventor => {
        if (contraventor.estado == 'PRESUNTO CONTRAVENTOR') {
          bandera = false;
        }
      });
    }

    if (bandera) {
      this.props
        .updateEstadoExpediente({
          variables: {
            _id: this.props.expediente._id,
            nuevoEstado: estado,
          },
        })
        .then(respuesta => {
          // console.log('LA RESPEUSTA ES:', respuesta);
          if (respuesta.data.updateEstadoExpediente) {
            notification.success({
              message: 'Estado Actualizado Correctamente',
              description:
                'El estado del expediente digital se actualizó correctamente',
            });

            this.props.data
              .refetch({
                _id: this.props.match.params.id,
              })
              .catch(err => {
                console.log('ERROR EN EL REFETCH');
                console.log(err);
                errorService(err, {
                  _id: this.props.match.params.id,
                });
              });
          }
        })
        .catch(error => {
          console.log('EXISTIO UN ERROR A LA HORA DE ACTUALIZAR EL ESTADO');
          console.log(error);
          errorService(error, {
            _id: this.props.expediente._id,
            nuevoEstado: estado,
          });
        });
    } else {
      notification.warning({
        message: 'NO SE PUEDE FINALIZAR EL ESTADO DEL EXPEDIENTE',
        description:
          'Existe al menos un contraventor con el estado de presunto contraventor. Absuelva o Sancione al contraventor para poder continuar.',
      });

      this.props.data
        .refetch({
          _id: this.props.match.params.id,
        })
        .then(res => {
          this.props.actionsExpedientes.actualizarEstado(
            res.data.getExpedientePorId.estado
          );
        })
        .catch(err => {
          console.log('ERROR EN EL REFETCH');
          console.log(err);
          errorService(err, {
            _id: this.props.match.params.id,
          });
        });
    }
  };

  confirmarActuacion = id => {
    this.setState({
      loadingConfirmarActuacion: true,
    });
    this.props
      .confirmarActuacion({
        variables: {
          _id: id,
        },
      })
      .then(res => {
        if (res.data.confirmarActuacion) {
          this.setState({
            loadingConfirmarActuacion: false,
          });
          this.props.actionsExpedientes.actualizarActuacion(
            res.data.confirmarActuacion
          );
        }
      })
      .catch(err => {
        console.log('ERROR: ');
        console.log(err);
        this.setState({
          loadingConfirmarActuacion: false,
        });
        errorService(err, {
          _id: id,
        });
      });
  };

  onImprimirActuacion = record => {
    imprimir(record.textoNota);

    if (record.tipo && record.tipo != 'RECIBO') {
      this.props.agregarRegistroAuditoria({
        variables: {
          _id: record._id,
          registro: {
            fecha: moment().toDate(),
            idUsuario: this.props.getUsuario.getUsuario
              ? this.props.getUsuario.getUsuario._id
              : '',
            descripcion: 'Impresión de la Actuación',
          },
        },
      });
    }
  };

  mostrarModalMandarEmail = idDoc => {
    this.setState({
      visibleModalMandarEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalMandarEmail = () => {
    this.setState({
      visibleModalMandarEmail: false,
      idDocumento: null,
    });
  };

  mostrarModalVisorEmail = idDoc => {
    this.setState({
      visibleModalVisorEmail: true,
      idDocumento: idDoc,
    });
  };

  ocultarModalVisorEmail = () => {
    this.setState({
      visibleModalVisorEmail: false,
      idDocumento: null,
    });
  };

  verificarExistenciaRecibo = () => {
    let resultado = false;

    let recibos = this.props.expediente.recibos;

    _.forEach(recibos, recibo => {
      // console.log('EL RECIBO ES: ', recibo);

      if (
        recibo.contraventor &&
        this.state.contraventorMostrar &&
        recibo.contraventor._id === this.state.contraventorMostrar._id
      ) {
        resultado = true;
      }
    });

    // console.log('VOY A DEVOLVER: ', resultado);

    return resultado;
  };

  // eslint-disable-next-line no-unused-vars
  generarRecibo = _id => {
    const expediente = this.props.expediente;
    const contraventor = this.state.contraventorMostrar;
    let { persona } = contraventor;
    this.props
      .insertRecibo({
        variables: {
          objRecibo: {
            nombre: `Recibo de ${persona.apellido} ${persona.nombre}`,
            tipo: 'RECIBO',
            idExpediente: expediente._id,
            idContraventor: contraventor._id,
          },
        },
      })
      .then(res => {
        if (res.data.insertRecibo) {
          this.props.actionsExpedientes.agregarRecibo(res.data.insertRecibo);

          notification.success({
            message: 'Recibo agregado correctamente',
            description:
              'El Recibo se registró correctamente en la base de datos',
          });

          verPdf(
            res.data.insertRecibo.recibo64,
            `Recibo_Num_${res.data.insertRecibo._id}`
          );

          // this.props.history.goBack();
        }
      })
      .catch(err => {
        console.log('ERROR EN INSERTAR EL RECIBO: ', err);

        notification.error({
          message: 'Error al agregar el recibo',
          description: 'Se ha producido un error al agregar el recibo',
        });

        errorService(err, {
          mutation: 'INSERT RECIBO',
          objRecibo: {
            nombre: `Recibo de ${persona.apellido} ${persona.nombre}`,
            tipo: 'RECIBO',
            idExpediente: expediente._id,
            idContraventor: contraventor._id,
          },
        });
      });

    // this.props.finalizarGeneracionRecibo();
  };

  render() {
    // console.log('PROPS', this.props);

    let expediente =
      this.props.data.getExpedientePorId || this.props.expediente;
    if (this.props.data.loading || !expediente || this.state.loading) {
      return <Loading />;
    }

    let usuario = this.props.getUsuario.getUsuario;
    // console.log('USUARIO: ', usuario);

    // console.log('expe: ');
    // console.log(expediente);

    // console.log('CONTR');
    // console.log(this.state.contraventorMostrar);
    let botonRecibo = this.verificarExistenciaRecibo();
    // let botonRecibo = false;
    // console.log('BOTON RECIBO: ', botonRecibo);
    const menu = (
      <Menu>
        <Menu.Item key="1">
          <Button
            style={{ width: '100%' }}
            onClick={() => this.mostrarDetallesContraventor()}
          >
            <FaAddressCard /> Detalle
          </Button>
        </Menu.Item>
        <Menu.Item key="2">
          <Button
            disabled={
              (this.state.contraventorMostrar.sancion &&
                this.state.contraventorMostrar.sancion.fechaSancion != null) ||
              this.state.contraventorMostrar.estado != 'PRESUNTO CONTRAVENTOR'
            }
            style={{ width: '100%' }}
            onClick={() => this.mostrarSancion()}
          >
            <FaBalanceScale /> Sancionar
          </Button>
        </Menu.Item>
        <Menu.Item key="3">
          <Button
            disabled={
              (this.state.contraventorMostrar.sancion &&
                this.state.contraventorMostrar.sancion.fechaSancion != null) ||
              this.state.contraventorMostrar.estado != 'PRESUNTO CONTRAVENTOR'
            }
            style={{ width: '100%' }}
            onClick={this.absolverContraventor}
          >
            <FaBalanceScale /> Absolver
          </Button>
        </Menu.Item>
        <Menu.Item key="9">
          <Button
            disabled={
              (this.state.contraventorMostrar.sancion &&
                this.state.contraventorMostrar.sancion.fechaSancion != null) ||
              this.state.contraventorMostrar.estado != 'PRESUNTO CONTRAVENTOR'
            }
            style={{ width: '100%' }}
            onClick={this.prescribirContraventor}
          >
            <FaBalanceScale /> Prescribir
          </Button>
        </Menu.Item>
        <Menu.Item key="4">
          <Button
            disabled={
              this.state.contraventorMostrar.estado != 'PRESUNTO CONTRAVENTOR'
            }
            style={{ width: '100%' }}
            onClick={this.desestimarContraventor}
          >
            <FaBalanceScale /> Desestimar
          </Button>
        </Menu.Item>
        <Menu.Item key="5">
          <Button
            disabled={
              (this.state.contraventorMostrar.sancion &&
                this.state.contraventorMostrar.sancion.fechaSancion == null) ||
              this.state.contraventorMostrar.estado == 'ABSUELTO' ||
              botonRecibo
            }
            style={{ width: '100%' }}
            onClick={() =>
              this.generarRecibo(this.state.contraventorMostrar._id)
            }
          >
            <FaDollarSign /> Generar Recibo
          </Button>
        </Menu.Item>
        <Menu.Item key="6">
          <Button
            style={{ width: '100%' }}
            onClick={() => this.buscarAntecedentes()}
          >
            <FaSearch /> Antecedentes
          </Button>
        </Menu.Item>
        <Menu.Item key="7">
          <Button
            style={{ width: '100%' }}
            onClick={() => this.mostrarModalDireccion()}
          >
            <FaEdit /> Actualizar Direccion
          </Button>
        </Menu.Item>
        <Menu.Item key="8">
          <Button
            style={{ width: '100%' }}
            type="danger"
            disabled={
              this.state.contraventorMostrar.estado ===
                'PRESUNTO CONTRAVENTOR' ||
              (usuario.rol != 'FUNCIONARIO' && usuario.rol != 'SUPERVISOR')
            }
            onClick={() => this.eliminarEstado()}
          >
            <FaTrash /> Eliminar Estado
          </Button>
        </Menu.Item>
        <Menu.Item key="10">
          <Button
            style={{ width: '100%' }}
            type="danger"
            onClick={() => this.sacarContraventor()}
          >
            <FaTrash /> Eliminar
          </Button>
        </Menu.Item>
      </Menu>
    );

    const colums = [
      {
        title: 'Documento',
        key: 'documento',
        render: contraventor =>
          contraventor.persona.tipo_doc + ' ' + contraventor.persona.num_doc,
      },
      {
        title: 'Nombre',
        key: 'nombre',
        render: contraventor =>
          contraventor.persona.nombre + ' ' + contraventor.persona.apellido,
      },
      {
        title: 'Estado',
        key: 'estado',
        render: contraventor => {
          switch (contraventor.estado) {
            case 'PRESUNTO CONTRAVENTOR':
              return (
                <Tag key={contraventor.estado} color="orange">
                  PRESUNTO CONTRAVENTOR
                </Tag>
              );
            case 'SANCIONADO':
              return (
                <Popover
                  content={
                    <div>
                      <p>Sancion: {contraventor.sancion.tipoSancion}</p>
                      <p>
                        Articulos sancionados:{' '}
                        {_.map(contraventor.sancion.articulos, articulo => {
                          return articulo.nombre + ' ';
                        })}
                      </p>

                      {!contraventor.sancion.tipoSancion && (
                        <p>Monto: ${contraventor.sancion.monto}</p>
                      )}

                      {contraventor.sancion.tipoSancion === 'MULTA' && (
                        <p>Monto: ${contraventor.sancion.monto}</p>
                      )}

                      {contraventor.sancion.tipoSancion === 'ARRESTO' && (
                        <p>
                          Cantidad dias: {contraventor.sancion.cantidadDias}
                        </p>
                      )}
                      {/* ARRESTO, TRABAJO COMUNITARIO y OTRO  usan campo observacion */}
                      {contraventor.sancion.tipoSancion &&
                        contraventor.sancion.tipoSancion !== 'MULTA' && (
                          <p>Observacion: {contraventor.sancion.observacion}</p>
                        )}
                    </div>
                  }
                  title={`Sancion de ${contraventor.persona.nombre} ${contraventor.persona.apellido} `}
                >
                  <Tag
                    onClick={() => console.log('CLICK')}
                    key={contraventor.estado}
                    color="red"
                  >
                    SANCIONADO
                  </Tag>
                </Popover>
              );
            case 'ABSUELTO':
              return (
                <Tag key={contraventor.estado} color="green">
                  ABSUELTO
                </Tag>
              );
            case 'DESESTIMADO':
              return (
                <Tag key={contraventor.estado} color="cyan">
                  DESESTIMADO
                </Tag>
              );
            case 'PRESCRIPTO':
              return (
                <Tag key={contraventor.estado} color="purple">
                  PRESCRIPTO
                </Tag>
              );
          }
        },
      },
      {
        title: '',
        key: 'acccion',
        render: record => (
          <span>
            <Dropdown
              onVisibleChange={() =>
                this.setState({ contraventorMostrar: record })
              }
              overlay={menu}
            >
              <Button style={{ marginLeft: 8 }}>
                Acciones <Icons.DownOutlined />
              </Button>
            </Dropdown>
          </span>
        ),
      },
    ];

    const colums2 = [
      {
        title: 'Nombre Documento',
        key: 'nombreActuacion',
        render: actuacion => actuacion.nombre,
      },
      {
        title: 'Fecha',
        key: 'fechaActuacion',
        render: actuacion =>
          moment(actuacion.fechaCreacion).format('DD/MM/YYYY'),
      },
      {
        title: 'Tipo',
        key: 'tipo',
        dataIndex: 'tipo',
      },
      {
        title: 'Estado',
        key: 'estado',
        dataIndex: 'estado',
      },
      {
        title: 'Acciones',
        key: 'acccion',
        render: record => (
          <span>
            {record.urlMinio && (
              <Button
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => this.descargarArchivo(record)}
              >
                <Icons.DownloadOutlined />
              </Button>
            )}
            {record.tipo == 'BORRADOR' && (
              <Button
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() =>
                  this.props.history.push(
                    `/contravenciones/actuacion/${record._id}`
                  )
                }
              >
                <Icons.EditOutlined />
              </Button>
            )}
            {record.tipo == 'BORRADOR' && (
              <Button
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                loading={this.state.loadingConfirmarActuacion}
                disabled={
                  usuario.rol != 'FUNCIONARIO' && usuario.rol != 'SUPERVISOR'
                }
                onClick={() => this.confirmarActuacion(record._id)}
              >
                <Icons.CheckOutlined />
              </Button>
            )}
            {usuario._id == usuario.organismo.responsable._id &&
              record.tipo != 'RECIBO' && (
                <Button
                  type="primary"
                  size="small"
                  style={{ marginLeft: 8 }}
                  disabled={usuario._id != usuario.organismo.responsable._id}
                  onClick={() => this.mostrarModalAuditoriaActuacion(record)}
                >
                  <Icons.ProfileOutlined />
                </Button>
              )}
            {record.tipo == 'ACTUACION' && (
              <Button
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => this.onImprimirActuacion(record)}
              >
                <Icons.PrinterOutlined />
              </Button>
            )}
            {record.tipo == 'ACTUACION' && (
              <Button
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => this.mostrarModalMandarEmail(record._id)}
              >
                <Icons.MailOutlined />
              </Button>
            )}
            {record.tipo == 'ACTUACION' && (
              <Button
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => this.mostrarModalVisorEmail(record._id)}
              >
                <Icons.SearchOutlined />
              </Button>
            )}
            <Button
              type="danger"
              size="small"
              disabled={
                usuario._id != usuario.organismo.responsable._id &&
                usuario.rol != 'SUPERVISOR'
              }
              style={{ marginLeft: 8 }}
              onClick={() => this.eliminarActuacion(record)}
            >
              <Icons.CloseOutlined />
            </Button>
          </span>
        ),
      },
    ];

    // console.log('EXP: ');
    // console.log(this.props.expediente);
    // console.log(this.state.contraventorMostrar);

    let colActuaciones = [];

    if (this.props.expediente.actuaciones) {
      colActuaciones = [
        ...colActuaciones,
        ...this.props.expediente.actuaciones,
      ];
    }

    if (this.props.expediente.recibos) {
      colActuaciones = [...colActuaciones, ...this.props.expediente.recibos];
    }

    // console.log("ACTUACIONES Y RECIBOS: ");
    // console.log(colActuaciones);
    let listaArticulos = this.props.getArticulos.getArticulos;
    if (listaArticulos) {
      var opciones = _.map(listaArticulos, this.crearOpciones);
    }

    // console.log('CONTRAVENTORES: ');
    // console.log(this.props.contraventores);

    return (
      <div>
        {this.props.main.cargarContraventorToggle && <SumarContraventor />}
        {!this.props.main.cargarContraventorToggle && (
          <div>
            <Layout
              style={{
                background: '#fff',
                padding: 24,
                minHeight: '80vh',
              }}
            >
              <Row>
                <Col span={4} offset={10}>
                  <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
                    <Icons.FileTextOutlined /> Expediente
                  </h2>
                </Col>
                <Col span={9} offset={1}>
                  <Button type="danger" onClick={this.volver}>
                    <Icons.BackwardOutlined />
                    Volver
                  </Button>
                </Col>
              </Row>
              <br />
              <div style={estiloContent}>
                <Row type={'flex'} justify={'center'}>
                  <Col span={22} offset={1}>
                    <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                      Expediente: <strong>{expediente.codigoOrganismo}</strong>{' '}
                      <strong>{expediente.tipo.nombre}</strong>{' '}
                      <strong>{expediente.numero}</strong>{' '}
                      <strong>{expediente.anio}</strong>
                    </h2>
                  </Col>
                </Row>

                <Row
                  style={{ marginTop: 20 }}
                  type={'flex'}
                  justify={'space-between'}
                >
                  <Col span={10} offset={2}>
                    <h3>Caratula:</h3>
                  </Col>
                  <Col span={9}>
                    <Button
                      size="small"
                      type="primary"
                      onClick={() => this.setState({ caratulaEditable: true })}
                      icon={<Icons.EditOutlined />}
                    >
                      Editar
                    </Button>
                    <Button
                      size="small"
                      icon={<Icons.SaveOutlined />}
                      onClick={() => this.guardarCaratula()}
                    >
                      Guardar
                    </Button>
                    <Button
                      size="small"
                      type="primary"
                      icon={<Icons.PrinterOutlined />}
                      onClick={() => this.imprimirCaratula()}
                    >
                      Imprimir
                      {/**/}{' '}
                    </Button>
                  </Col>
                </Row>

                <Row style={{ marginTop: 5 }} type={'flex'}>
                  <Col span={22} offset={1}>
                    <p>
                      <TextArea
                        /* eslint-disable-next-line react/no-string-refs */
                        ref="caratula"
                        id="caratulaId"
                        style={{ marginLeft: 25, width: '85%' }}
                        autoSize={{ minRows: 3, maxRows: 8 }}
                        defaultValue={expediente.caratula}
                        onChange={e =>
                          this.setState({
                            caratula: e.target.value,
                          })
                        }
                        disabled={!this.state.caratulaEditable}
                      />
                    </p>
                  </Col>
                </Row>

                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Organismo:</h3>
                  </Col>
                  <Col span={11}>
                    {expediente.organismo
                      ? expediente.organismo.nombre
                      : 'SIN DATOS'}
                  </Col>
                </Row>
                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Fecha de Ingreso:</h3>
                  </Col>
                  <Col span={11}>
                    {expediente.fechaIngreso
                      ? moment(expediente.fechaIngreso).format('DD/MM/YYYY')
                      : 'SIN DATOS'}
                  </Col>
                </Row>
                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Fecha de Prescripción:</h3>
                  </Col>
                  <Col span={11}>
                    {expediente.fechaPrescripcion
                      ? moment(expediente.fechaPrescripcion).format(
                          'DD/MM/YYYY'
                        )
                      : 'SIN DATOS'}
                  </Col>
                </Row>

                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Estado del Expediente:</h3>
                  </Col>
                  <Col span={11}>
                    <Select
                      size={'default'}
                      placeholder="Seleccionar"
                      defaultValue={
                        expediente.estado ? expediente.estado : undefined
                      }
                      onChange={this.actualizarEstado}
                      value={expediente.estado}
                      style={{ width: '70%' }}
                    >
                      <Option value="EN TRAMITE">
                        <Tag color="#108ee9">EN TRAMITE</Tag>
                      </Option>

                      <Option
                        // disabled={
                        //   this.props.contraventores.filter(
                        //     contraventor => contraventor.estado === 'PRESUNTO CONTRAVENTOR'
                        //   ).length > 0
                        // }
                        value="FINALIZADO"
                      >
                        <Tag color="#f50">FINALIZADO</Tag>
                      </Option>

                      <Option value="OTRO">
                        <Tag color="#36f2f5">OTRO</Tag>
                      </Option>
                    </Select>
                  </Col>
                </Row>
                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Articulos del Expediente:</h3>
                  </Col>
                  <Col span={11}>
                    <Select
                      mode="multiple"
                      size={'default'}
                      placeholder="Seleccionar"
                      defaultValue={this.generarOpcionesIniciales()}
                      onChange={this.actualizarArticulos}
                      style={{ width: '70%' }}
                    >
                      {opciones}
                    </Select>
                  </Col>
                </Row>
                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Fecha del Hecho</h3>
                  </Col>
                  <Col span={11}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      defaultValue={
                        expediente.fechaHecho
                          ? moment(expediente.fechaHecho)
                          : undefined
                      }
                      placeholder="Ingrese la Fecha"
                      onChange={this.enCambioFechadelhecho}
                      style={{ width: '70%' }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: 5 }} type={'flex'} justify={'center'}>
                  <Col span={11} offset={1}>
                    <h3>Num. Exp. Policial</h3>
                  </Col>
                  <Col span={11}>
                    <Input.Search
                      style={{ width: '70%' }}
                      onSearch={this.enCambioNumeroExpPolicial}
                      enterButton={<Icons.SaveOutlined />}
                      defaultValue={
                        expediente.numeroExpPolicial
                          ? expediente.numeroExpPolicial
                          : ''
                      }
                    />
                  </Col>
                </Row>
                <Row type={'flex'} justify={'center'}>
                  <Col span={22} offset={1}>
                    <Table
                      rowKey={'_id'}
                      bordered
                      size="small"
                      title={() => (
                        <Row>
                          <Col offset={8} span={8}>
                            <h3 style={{ textAlign: 'center', marginTop: 5 }}>
                              Contraventores
                            </h3>
                          </Col>
                          <Col span={8}>
                            <Button
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() =>
                                this.props.actionsMain.setCargaContraventor(
                                  !this.props.main.cargarContraventorToggle
                                )
                              }
                            >
                              <Icons.PlusOutlined />
                            </Button>
                          </Col>
                        </Row>
                      )}
                      pagination={false}
                      style={{ maxWidth: '85%', marginTop: 10 }}
                      dataSource={this.props.contraventores}
                      columns={colums}
                    />
                  </Col>
                </Row>

                <Row type={'flex'} justify={'center'} style={{ marginTop: 30 }}>
                  <Col span={22} offset={1}>
                    <Table
                      rowKey={'_id'}
                      bordered
                      size="small"
                      pagination={false}
                      title={() => (
                        <Row>
                          <Col offset={8} span={8}>
                            <h3 style={{ textAlign: 'center', marginTop: 5 }}>
                              Actuaciones
                            </h3>
                          </Col>
                          <Col span={8}>
                            <Button
                              type="primary"
                              style={{ float: 'right' }}
                              onClick={() =>
                                this.mostrarModalUploader(
                                  !this.state.visibleModalUploader
                                )
                              }
                            >
                              <Icons.UploadOutlined />
                            </Button>
                            <Button
                              type="primary"
                              style={{ float: 'right', marginRight: 5 }}
                              onClick={() =>
                                this.props.history.push(
                                  `${this.props.expediente._id}/agregarActuacion`
                                )
                              }
                            >
                              <Icons.FileTextOutlined />
                            </Button>
                          </Col>
                        </Row>
                      )}
                      style={{ maxWidth: '85%', marginTop: 10 }}
                      dataSource={colActuaciones}
                      columns={colums2}
                    />
                  </Col>
                </Row>
              </div>
            </Layout>
          </div>
        )}
        <DetalleContraventor
          visible={this.state.visibleSumarContraventor}
          contraventor={this.state.contraventorMostrar}
          ocultarModal={this.ocultarDetallesContraventor}
        />
        <ModalSancion
          visibleSancion={this.state.visibleSancion}
          ocultarModalSancion={this.ocultarSancion}
          articulos={this.props.expediente.articulos}
          contraventor={this.state.contraventorMostrar}
        />

        <ModalActualizarDireccion
          visibleActualizarDireccion={this.state.visibleActualizarDireccion}
          ocultarModalDireccion={this.ocultarModalDireccion}
          contraventor={this.state.contraventorMostrar}
        />

        <ModalAntecedentes
          mostrarModalAntecedentes={this.state.mostrarModalAntecedentes}
          ocultarModalAntecendetes={this.ocultarModalAntecendetes}
          expedientes={this.state.expedientesAntecedentes}
          expedientesExternos={this.state.expedientesAntecedentesExternos}
          contraventor={this.state.contraventorMostrar}
        />

        <ModalAuditoriaActuacion
          mostrarModalAuditoriaActuacion={
            this.state.mostrarModalAuditoriaActuacion
          }
          ocultarModalAuditoriaActuacion={this.ocultarModalAuditoriaActuacion}
          auditoria={this.state.actuacion.auditoria}
        />

        <ModalUploader
          mostrarModalUploader={this.state.visibleModalUploader}
          ocultarModalUploader={this.ocultarModalUploader}
          expediente={this.props.expediente}
          contraventor={this.state.contraventorMostrar}
          match={this.props.match}
        />

        <ModalMandarEmail
          visibleModalMandarEmail={this.state.visibleModalMandarEmail}
          ocultarModalMandarEmail={this.ocultarModalMandarEmail}
          idDocumento={this.state.idDocumento}
        />

        <ModalVisorEmail
          id={this.state.idDocumento}
          visibleModalLogsEmail={this.state.visibleModalVisorEmail}
          ocultarModalLogsEmail={this.ocultarModalVisorEmail}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsExpedientes: bindActionCreators(actionsExpedientes, dispatch),
  actionsContraventores: bindActionCreators(actionsContraventores, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerExpediente));
